module.exports = __webpack_public_path__ + "static/img/zs-nan@2x.2658e7c6.png";